module.exports = __webpack_public_path__ + "img/13.068941b2.jpg";